import { Columns } from "lqx-react";
import React, { useMemo } from "react";
import { AssetEvent } from "../api/assetEvent";
import { AssetChange } from "../api/assetChange";
import { AttributesMixin } from "@type-r/models";
import { ExternalSystem } from "../api/externalSystemRequest";
import { InblockedAssetEventStatusItem } from "./inblocked-asset-event-status-item";

export const InblockedAssetsEventStatus = <TAssetChange extends AttributesMixin<AssetChange> & AssetChange>({ assetChange, externalSystems }: {
    assetChange: TAssetChange,
    externalSystems: ExternalSystem[]
}) => {
    const assetEventsDictionary = useMemo(() => {
        const dictionary = {};
        if (!assetChange.assetEvents)
            return dictionary;

        assetChange.assetEvents.forEach((item: AssetEvent) => {
            if (item.eventTypeId)
                dictionary[ item.eventTypeId ] = item;
        });
        return dictionary;
    }, [ assetChange[ '_changeToken' ] ]);

    const externalSystemsDictionary = useMemo(() => {
        const dictionary = {};
        externalSystems.forEach(item => {
            if (item.assetEventType)
                dictionary[ item.assetEventType ] = item;
        });
        return dictionary;
    }, [ externalSystems[ '_changeToken' ] ]);

    return <Columns key={ assetChange.id }>
        {
            externalSystems.map(externalSystem => {
                const assetEvent = assetEventsDictionary[ externalSystem.assetEventType ];
                return <InblockedAssetEventStatusItem assetEvent={assetEvent} externalSystem={externalSystem} externalSystemsDictionary={externalSystemsDictionary}></InblockedAssetEventStatusItem>
            })
        }
    </Columns>
}